module.exports = __webpack_public_path__ + "img/user.46bb16f8.png";